import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IntakeFormRes } from "../patients/index.type";

const useFetchIntakeForm = ({ planId }: { planId: string }) => {
  const [intakeForm, setIntakeForm] = React.useState<IntakeFormRes>();

  const { loading: intakeFormLoading, makeApiCall } = useApi({
    url: `/rtm/template/plan?planId=${planId}`,
    method: "GET",
  });

  const getIntakeFormData = async ({
    clearFirst = false,
  }: { clearFirst?: boolean } = {}) => {
    if (clearFirst) {
      setIntakeForm(undefined);
    }
    if (!planId) return;

    const { response, error } = await makeApiCall<undefined, IntakeFormRes>();

    if (response?.status === "success") {
      setIntakeForm(response);
    } else {
      setIntakeForm(undefined);
      toast.error(
        "Something went wrong while fetching intake form. Please try again later"
      );
    }
  };

  return {
    intakeForm,
    getIntakeFormData,
    intakeFormLoading,
  };
};

export default useFetchIntakeForm;
